import { isNumber, isString } from 'lodash';
import { v4 as uuid } from 'uuid';
import dayjs from 'dayjs';
import moment from 'moment';

export const getAllParentFromTarget = (uid, data) => {
	let mapData = {};
	let parents = [];
	const notAbleToBeParent = [
		'Time',
		'Checkbox',
		'Select',
		'Calendar',
		'TextArea',
		'Text',
		'Radio',
		'HRadio',
		'File',
		'Hidden',
		'Currency',
		'Number',
		'Integer',
		'Password',
		'Button',
		'file_table',
	];

	const allChildIds = getAllChildIds(uid, data);

	data?.forEach((item) => {
		if (allChildIds?.indexOf(item?.uid) === -1) {
			mapData[item.uid] = {
				...item,
			};
		}
	});

	// function findParent(uid) {
	//   const currentItem = mapData?.[uid];

	// let option = {
	//   label: currentItem?.type + " " + currentItem?.code,
	//   value: currentItem?.uid
	// }

	//   parents.push(option);

	//   if(currentItem?.parentId) {
	//       return findParent(currentItem?.parentId);
	//   }

	//   return null;
	// }

	for (const key in mapData) {
		const currentItem = mapData?.[key];

		if (notAbleToBeParent.indexOf(currentItem?.type) < 0) {
			let option = {
				label: currentItem?.type?.toLowerCase() === 'design' ? 'Form' : currentItem?.type + ' ' + currentItem?.code,
				value: currentItem?.uid,
			};

			parents.push(option);
		}
	}

	// findParent(uid);

	return parents;
};

export const allInputFieldCode = (uid, data) => {
	const filedType = [
		'Time',
		'Checkbox',
		'Select',
		'Calendar',
		'TextArea',
		'Text',
		'Radio',
		'HRadio',
		'File',
		'Hidden',
		'Currency',
		'Number',
		'Integer',
		'Password',
		'Button',
	];
	const inputFields = [];

	data?.forEach((item) => {
		if (filedType.indexOf(item?.type) > -1 && uid !== item?.uid) {
			let option = {
				label: `${item?.label} (${item?.code})`,
				value: item?.code,
			};

			inputFields.push(option);
		}
	});

	return inputFields;
};

export const getAllChildIds = (uid, data) => {
	function findAllChildren(list, parentId) {
		let children = list.filter((item) => item.parentId === parentId);
		let allChildren = [...children];
		children.forEach((child) => {
			allChildren = allChildren.concat(findAllChildren(list, child.uid));
		});
		return allChildren;
	}

	const childIds = findAllChildren(data, uid)?.map((item) => item?.uid);

	return [uid, ...childIds];
};

export const nestedDataGenerator = (payload) => {
	let mapData = {};
	let root = [];

	payload?.forEach((item) => {
		mapData[item.uid] = {
			...item,
			children: [],
			...(item?.type?.toLowerCase() === 'table' && { colDef: [] }),
		};
	});

	payload?.forEach((item) => {
		if (item.parentId) {
			let parent = mapData?.[item.parentId];
			const childNode = mapData[item.uid];
			if (parent?.type?.toLowerCase() === 'table') {
				parent?.colDef?.push(childNode);
			} else if (parent?.type?.toLowerCase() === 'file_table') {
				console.log('');
			} else {
				parent?.children?.push(childNode);
			}
		} else {
			root.push(mapData[item.uid]);
		}
	});

	return root;
};

export const nestedToFlatArrayOfObject = (data) => {
	const flatData = [];

	function recursiveLoopFunction(data, parentId) {
		const uid = uuid();
		let objCopy = {
			...data,
			uid: uid,
			parentId: parentId,
		};

		delete objCopy.children;

		flatData.push(objCopy);

		if (data?.children === null && data?.colDef === null) {
			return;
		}

		if (data?.colDef) {
			return data?.colDef?.map((item) => {
				return recursiveLoopFunction(item, uid);
			});
		}

		return data?.children?.map((item) => {
			return recursiveLoopFunction(item, uid);
		});
	}

	recursiveLoopFunction(data, null);

	return flatData;
};

export const cloneNestedToFlatArrayOfObject = (data) => {
	const flatData = [];

	function recursiveLoopFunction(data) {
		const uid = uuid();
		let objCopy = {
			...data,
		};

		delete objCopy.children;

		flatData.push(objCopy);

		if (data?.children === null && data?.colDef === null) {
			return;
		}

		if (data?.colDef) {
			return data?.colDef?.map((item) => {
				return recursiveLoopFunction(item, uid);
			});
		}

		return data?.children?.map((item) => {
			return recursiveLoopFunction(item, uid);
		});
	}

	recursiveLoopFunction(data, null);

	return flatData;
};

export const currencyFormatter = (value) => {
	if (!value) return '-';

	if (isString(value)) return value;

	if (isNumber(value)) {
		return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
	}

	return value;
};

export const numberFormatter = (value) => {
	if (!value) return '-';

	if (isString(value)) return value;

	if (isNumber(value)) {
		return new Intl.NumberFormat('en-IN').format(value);
	}

	return value;
};

export const taskCodeGenerator = (processCode, taskCode) => {
	if (!processCode || !taskCode) return '';
	if (processCode && taskCode) return `${processCode}-${taskCode}`;
};

export const formatDateToUTC = (dates) => {
	const formatDateToUTC = (date) => {
		const utcDate = new Date(date);
		utcDate.setMinutes(utcDate.getMinutes() - utcDate.getTimezoneOffset()); // Remove local timezone offset
		return utcDate.toISOString(); // Format as "YYYY-MM-DD"
	};

	const formattedDates = Array.isArray(dates)
		? dates.map(formatDateToUTC) // Format each date in the range
		: dates
			? formatDateToUTC(dates) // Format the single date
			: null;

	return formattedDates;
};

export const formatTimeToUTC = (times) => {
	const formatTimeToUTC = (time) => {
		if (!time) return null;

		const utcTime = new Date(time);
		utcTime.setMinutes(utcTime.getMinutes() - utcTime.getTimezoneOffset()); // Remove local timezone offset

		// Extract the UTC time in "HH:mm:ss" format
		return utcTime.toISOString().split('T')[1].split('.')[0]; // Get only time part
	};

	const formattedTimes = Array.isArray(times)
		? times.map(formatTimeToUTC) // Format each time in the array
		: times
			? formatTimeToUTC(times) // Format the single time
			: null;

	return formattedTimes;
};

function getNestedValue(obj, keys) {
	return keys.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
}

export const findChanges = (modifiedFields, initialValues) => {
	return modifiedFields.filter((field) => {
		if (field.touched) {
			const initialValue = getNestedValue(initialValues, field.name);

			return JSON.stringify(field.value) !== JSON.stringify(initialValue); // Check if values are different
		}
		return false;
	});
};

export const encodeQueryParamData = (data) => {
	let stringifyData = data;

	if (typeof data !== 'string') {
		stringifyData = JSON.stringify(data);
	}

	return btoa(stringifyData);
};

export const decodeQueryParamData = (decodedData) => {
	let encodedData = '';

	try {
		encodedData = atob(decodedData);

		return JSON.parse(encodedData);
	} catch (error) {
		return null;
	}
};

// export const handlePV = (value, key, multiTableName, documentField) => {
// 	if (dayjs(value)?.isValid()) {
// 		return value;
// 	}

// 	if (key === multiTableName || key === documentField || key === 'HiddenForm') {
// 		if (typeof value !== 'string') {
// 			return JSON.stringify(value);
// 		}
// 		return value;
// 	}

// 	return value;
// };

export const handlePV = (value, key, multiTableName, documentField) => {
	if (value == null) {
		return null;
	}

	if (dayjs(value)?.isValid()) {
		return value;
	}

	if (key === multiTableName || key === documentField || key === 'HiddenForm') {
		if (typeof value !== 'string') {
			return JSON.stringify(value);
		}
		return value;
	}

	return value;
};

export const disableAllPastDates = (current) => {
	// Disable dates before today
	return current && current < dayjs().startOf('day');
};
export const disablePastDates = (current) => {
	const today = dayjs();
	const isFutureFirstDay =
		current &&
		current.date() === 1 && // Only the 1st day of the month
		current.isAfter(today.endOf('day')); // Ensure the date is in the future

	return !isFutureFirstDay;
};

export const formatMomentDate = (dateString, format = 'lll') => {
	if (!dateString) return 'No Date Available';
	const date = moment(dateString);
	return date.isValid() ? date.format(format) : 'Invalid Date';
};

export const formatNumber = (value, decimalPlaces = 2) => {
	// First check if value is null or undefined
	if (value === null || value === undefined) {
		return '0.00';
	}

	// Handle various input types
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);

	// Check if the result is a valid number
	if (isNaN(num)) {
		return '0.00';
	}

	return num.toLocaleString('en-US', {
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces,
	});
};

export const generateExcelFileName = (xlsxFileReName) => {
	// Check if filename matches the pattern "<number>_date.xlsx"
	const pattern = /^(\d+)_date$/i;

	if (pattern.test(xlsxFileReName)) {
		// Extract the number from the filename
		const match = xlsxFileReName.match(pattern);
		const numberPart = match[1];

		// Get current date components
		const today = new Date();
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
		const day = String(today.getDate()).padStart(2, '0');

		// Format date as YYYY.MM.DD
		const formattedDate = `${year}.${month}.${day}`;

		// Create new filename
		return `${numberPart}_${formattedDate}`;
	}

	// Return original filename if pattern doesn't match
	return xlsxFileReName;
};

export const enhanceColumnsWithFiltering = (columns) => {
	return columns.map((column) => {
		// Create a copy to avoid modifying the original objects
		const enhancedColumn = { ...column };

		// For text columns, explicitly define the filter function
		if (enhancedColumn.dataType?.toLowerCase() === 'text') {
			enhancedColumn.filterFn = 'includesString';
		} else if (enhancedColumn.dataType?.toLowerCase() === 'number') {
			enhancedColumn.filterFn = 'numberFilter';
		}

		return enhancedColumn;
	});
};

export const getFileSize = (bytes) => {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	const size = bytes / Math.pow(k, i);
	return `${size.toFixed(2)} ${sizes[i]}`;
};

export const utcConverterISOString = (dayjsDate) => {
	const toISOString = dayjs(dayjsDate).toISOString();

	const utcDate = dayjs?.utc(toISOString);

	return utcDate.add(6, 'hour');
};
